import { useQuery } from "@apollo/client";
import { OrganizationEventsDocument } from "../../__generated__/graphql";

export default function useOrganizationEvents({
  afterDate,
  beforeDate,
}: {
  afterDate: string | null;
  beforeDate: string | null;
}) {
  const { data, loading, error, refetch } = useQuery(
    OrganizationEventsDocument,
    {
      variables: {
        filter: {
          after: afterDate,
          before: beforeDate,
        },
      },
    }
  );

  return { data, loading, error, refetch };
}
